import authentication from '@feathersjs/authentication';
import localAuth from '@feathersjs/authentication-local';

const { authenticate } = authentication.hooks;
const { hashPassword, protect } = localAuth.hooks;

export {
  authenticate,
  hashPassword as hash_password,
  protect,
};

export eventlog from './eventlog';
export log from './log';
export station_id from './station_id';
export error_handler from './error_handler';

export function jwt_auth() { return authenticate( 'jwt' ); }
export function protect_password() { return protect( 'password' ); }

export function auth( type ) {
  return authenticate( 'station', 'jwt' );
}
